import { SequenceMenu } from '@sequencehq/core-components'
import { ArchiveCustomerModal } from '../modals/archiveCustomer/ArchiveCustomerModal'
import { usePermissions } from 'lib/rbac'

export const ArchiveCustomerMenuItem = (props: {
  customerId: string
  onClose?: () => void
  disabled?: boolean
  'data-testid'?: string
}) => {
  const { can } = usePermissions()

  if (!can('org.customer:archive')) {
    return null
  }

  return (
    <ArchiveCustomerModal
      customerId={props.customerId}
      onClose={() => props.onClose?.()}
      trigger={
        <SequenceMenu.Item
          uuid="archive-customer"
          label="Archive customer"
          destructive
          isDisabled={props.disabled}
          data-testid={props['data-testid'] ?? 'archiveCustomer.menuItem'}
        />
      }
    />
  )
}
